import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { BaseResponse, IRefundInvoiceResponse } from "../../typings";
import { REFUND_INVOICE } from "../../configs";
import { RefundType } from "../../typings/enum/RefundType";
import { IRefundInvoiceRequest } from "../../typings/interfaces/requests/refund-invoice-request";

export const refundInvoiceAction = createAsyncThunk(
  "cart/refundInvoice",
  async (payload: IRefundInvoiceRequest, { rejectWithValue }) => {
    try {
      const response = await axios.post<
        BaseResponse<IRefundInvoiceResponse | null>
      >(REFUND_INVOICE, payload);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
